/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from '@emotion/core';
import React, { useState } from 'react';
import { ModalProps } from 'antd/lib/modal';
import { useThemeSwitcher } from 'react-css-theme-switcher';
import { Modal, DatePicker } from 'antd';
import icon from '~components/_common/icon/icon';

import doReturnTheme from '~src/styles/themeEngine';
import { useIntl } from 'react-intl';
import moment from 'moment';
import { appLog } from '~src/utils/log';
import { DatePickerProps } from 'antd/lib/date-picker';
import { setStorageTimestamp } from '~src/utils/sessionstorageQueries';

interface TimeMachineModalProps extends Partial<ModalProps> {
  modalState: boolean;
}

export const TimeMachineModal: React.FC<TimeMachineModalProps> = ({
  modalState,
  onCancel,
  onOk,
}) => {
  const [timeMachineDate, setTimeMachineDate] = useState<string>();

  const { currentTheme } = useThemeSwitcher();
  const theme = doReturnTheme(currentTheme);
  const intl = useIntl();

  const style = {
    container: {},
    titleBtn: {
      color: theme.colors.secondary,
      fontSize: '20px',
    },
    closeBtn: {
      color: theme.colors.darkGray,
      marginTop: '18px',
      fontSize: '20px',
      transition: '0.3s',
    },
  };

  const disabledDate = (current) => {
    // Can not select days after today
    return current && current > moment();
  };

  const onChange: DatePickerProps['onChange'] = (value, dateString) => {
    appLog('Selected Time: ', value);
    appLog('Formatted Selected Time: ', dateString);
  };

  const onSubmit = (value: DatePickerProps['value']) => {
    if (!value) return;
    setStorageTimestamp(value);
    setTimeMachineDate(String(value.unix()));
  };

  return (
    <Modal
      title={
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            alignItems: 'center',
            fontSize: '18px',
            fontWeight: 'bold',
          }}>
          {icon('far', 'history', style.titleBtn)}

          {intl.formatMessage({ id: 'time-machine' })}
        </div>
      }
      centered
      okButtonProps={{ disabled: !timeMachineDate }}
      visible={modalState}
      onCancel={onCancel}
      onOk={() => {
        timeMachineDate &&
          window.sessionStorage.setItem('timeMachineDate', timeMachineDate);
        // @ts-ignore-line
        onOk && onOk();
      }}
      okText={intl.formatMessage({ id: 'enter' })}
      cancelText={intl.formatMessage({ id: 'cancel' })}
      closeIcon={icon('far', 'times', style.closeBtn, 'close')}
      width={420}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
        }}>
        <b>{intl.formatMessage({ id: 'select-date-time' })}</b>
        <DatePicker
          format="DD/MM/YYYY - HH:mm"
          disabledDate={disabledDate}
          showTime
          onChange={onChange}
          onOk={onSubmit}
          style={{
            width: '50%',
            margin: '4px 0px 15px -1px',
          }}
        />
        <div
          style={{
            color: theme.colors.text.secondary,
          }}>
          {intl.formatMessage({ id: 'time-machine-description' })}
        </div>
      </div>
    </Modal>
  );
};
